angular.module('qkr').controller('beneficiaryDefinitionListController', ($scope, $uibModalInstance, utils, customField,
                                                                         beneficiariesService, listLength, createMode, managedMerchant,
                                                                         FormHelper, gettextCatalog) => {
	$scope.form = {};
	const formHelper = new FormHelper($scope);

    $scope.settingTypes = [
        {type: 'DROPDOWN', display: gettextCatalog.getString('Drop Down Selection')},
        {type: 'STRING', display: gettextCatalog.getString('User Entry - Alphanumeric')},
        {type: 'INTEGER', display: gettextCatalog.getString('User Entry - Numeric')}
    ];

	$scope.init = function() {
		$scope.customFieldPos = 0;
		$scope.previousSettings = [];
		if (createMode == 1) {
			for (let i = 0; i < customField.length; i++) {
				const entry = {
					fieldLabel: customField[i]
				};
				$scope.previousSettings.push(entry);
			}
		}
		$scope.loadFields();
	},

	$scope.loadFields = function() {
		// 0 CREATE 1
		// 1 CREATE LIST
		// 2 UPDATE
		switch (createMode) {
			case 0 :
				// CREATE
				$scope.definitionListMode = gettextCatalog.getString('Create Profile for Student Settings');
				$scope.form.originalName = '';
				$scope.form.fieldLabel = '';
				$scope.form.type = 'DROPDOWN';
				if (listLength) {
					$scope.form.listOrder = listLength;
				} else {
					$scope.form.listOrder = 0;
				}
				$scope.saveButton = 'Create';
				break;
			case 1 :
				// LIST
				// COMMON
				if ($scope.previousSettings[$scope.customFieldPos].fieldLabel == 'Custom') {
					$scope.form.fieldLabel = '';
    				$scope.form.type = 'DROPDOWN';
					$scope.lockFieldLabel = false;
				} else {
					$scope.form.fieldLabel = $scope.previousSettings[$scope.customFieldPos].fieldLabel;
    				$scope.form.type = 'DROPDOWN';
					$scope.lockFieldLabel = true;
				}

				$scope.definitionListMode = gettextCatalog.getString('Create Profile for Student Settings');
				if ($scope.customFieldPos + 1 < $scope.previousSettings.length) {
					$scope.saveButton = 'Next';
				} else {
					$scope.saveButton = 'Save';
				}
				if ($scope.customFieldPos > 0) {
					$scope.showBackButton = true;
				} else {
					$scope.showBackButton = false;
				}

				if ($scope.previousSettings[$scope.customFieldPos].originalName) {
					// UPDATE on previous
					$scope.form.id = $scope.previousSettings[$scope.customFieldPos].id;
					$scope.form.listOrder = $scope.previousSettings[$scope.customFieldPos].listOrder;
					$scope.form.originalName = $scope.previousSettings[$scope.customFieldPos].fieldLabel;
					$scope.ddOptions = $scope.previousSettings[$scope.customFieldPos].definitions;
					for (var i = 0; i < $scope.ddOptions.length; i++) {
						$scope.addDefinition($scope.ddOptions[i]);
					}
				} else {
					// CREATE
					$scope.form.originalName = '';
					if (listLength) {
						$scope.form.listOrder = $scope.customFieldPos + listLength;
					} else {
						$scope.form.listOrder = 0;
					}
				}

				break;
			case 2 :
				// UPDATE
				$scope.form.id = customField.id;
				$scope.form.fieldLabel = customField.fieldLabel;
				$scope.form.listOrder = customField.listOrder;
				$scope.form.originalName = angular.copy($scope.form.fieldLabel);
                $scope.form.type = customField.type;

				$scope.ddOptions = customField.optionsMap.dropdownOptions;
				$scope.definitionListMode = gettextCatalog.getString('Edit Profile for Student Settings');
                if ($scope.ddOptions) {
                    for (var i = 0; i < $scope.ddOptions.length; i++) {
                        $scope.addDefinition($scope.ddOptions[i]);
                    }
                }
				$scope.saveButton = 'Save';
				break;
		}
	},

	$scope.savePrevious = function(savedField) {
		$scope.previousSettings[$scope.customFieldPos].id = savedField.id;
		$scope.previousSettings[$scope.customFieldPos].fieldLabel = savedField.fieldLabel;
		$scope.previousSettings[$scope.customFieldPos].listOrder = savedField.listOrder;
		$scope.previousSettings[$scope.customFieldPos].definitions = savedField.optionsMap.dropdownOptions;
		$scope.previousSettings[$scope.customFieldPos].originalName = savedField.fieldLabel;
	},

	$scope.emptyFields = function() {
		$scope.form.fieldLabel = customField[$scope.customFieldPos];
		$scope.form.originalName = '';
		$scope.form.definitions = [];
        $scope.form.type = 'DROPDOWN';
	};

	$scope.delDefinition = function(beneficiaryDefinition) {
		let i;
		for (i = 0; i < $scope.form.definitions.length; i++) {
			if (beneficiaryDefinition === $scope.form.definitions[i]) {
				$scope.form.definitions.splice(i, 1);
				return;
			}
		}
	},

	$scope.addDefinition = function(newName) {
		const listName = angular.copy(newName);
		if (!($scope.validateNewName(newName))) {
			return;
		}
		if (!(utils.hasNoValue($scope.form.definitions))) {
			const input = {
				value: listName
			};
			$scope.form.definitions.push(input);
		} else {
			$scope.form.definitions = [{
				value: listName
			}];
		}
	},

	$scope.updateDefinition = function(updateName) {
		let i;
		for (i = 0; i < $scope.form.definitions.length; i++) {
			if (updateName === $scope.form.definitions[i]) {
				$scope.form.definitions[i] = updateName;
				return;
			}
		}
	},

	$scope.validateNewName = function(newName) {
		$scope.errorsNewName = null;
		let valid = true;
		const errorsNewName = {};
		const errorsDefinitions = {};
		errorsDefinitions.definitions = [];

		if (utils.hasNoValue(newName)) {
			errorsNewName.newName = gettextCatalog.getString('An option cannot be empty');
			valid = false;
		}

		if (!(utils.hasNoValue($scope.form.definitions))) {
			for (let i = 0; i < $scope.form.definitions.length; i++) {
				if ($scope.form.definitions[i].value === newName) {
					errorsNewName.newName = gettextCatalog.getString('Option already exists');

					const obj = {
						value: 'Options must be unique'
					};
					errorsDefinitions.definitions[i] = obj;
					valid = false;
				}
			}
		}

		if (!(utils.hasNoValue(errorsDefinitions))) {
			$scope.errorsDefinitions = null;
			$scope.errorsDefinitions = errorsDefinitions;
		}
		$scope.errorsNewName = errorsNewName;
		return valid;
	};

	$scope.validateForm = function() {
		$scope.errors = null;
		$scope.errorsNewName = null;
		$scope.errorsDefinitions = null;
		let valid = true;
		const errors = {};
		const errorsNewName = {};
		const errorsDefinitions = {};

		if (utils.hasNoValue($scope.form.fieldLabel)) {
			errors.fieldLabel = gettextCatalog.getString('A profile name must be entered');
			valid = false;
		}

        if ($scope.form.type === 'DROPDOWN') {
            if ((utils.hasNoValue($scope.form.definitions))) {
                errorsNewName.newName = gettextCatalog.getString('At least one option is required');
                valid = false;
            } else if ($scope.form.definitions.length < 1) {
                    errorsNewName.newName = gettextCatalog.getString('At least one option is required');
                    valid = false;
                }
        }

		if (!(utils.hasNoValue($scope.form.definitions))) {
			errorsDefinitions.definitions = [];
			for (let i = 0; i < $scope.form.definitions.length; i++) {
				for (let j = 0; j < $scope.form.definitions.length; j++) {
					// Duplicate check
					if ($scope.form.definitions[i].value == $scope.form.definitions[j].value && i != j) {
						var obj = {
							value: gettextCatalog.getString('Options must be unique')
						};
						errorsDefinitions.definitions[j] = obj;
						valid = false;
					}
					// Empty check. In here in case of > 1 empty fields
					if (utils.hasNoValue($scope.form.definitions[j].value)) {
						var obj = {
							value: gettextCatalog.getString('Options cannot be empty')
						};
						errorsDefinitions.definitions[j] = obj;
						valid = false;
					}
				}
			}
		}
		$scope.errors = errors;
		$scope.errorsNewName = errorsNewName;
		$scope.errorsDefinitions = errorsDefinitions;

		return valid;
	},

	$scope.save = function() {
		if((managedMerchant === null) || (managedMerchant === undefined)){
			$scope.managedSchool = null;
		} else {
			$scope.managedSchool = managedMerchant.id;
		}

		if (!$scope.validateForm()) {
			return;
		}

		// 0 CREATE 1
		// 1 CREATE LIST
		// 2 UPDATE
		switch (createMode) {
			case 0 :
				beneficiariesService.createBeneficiaryDefinition($scope.form).then((promise) => {
					const closeModal = $scope.createCallback(promise);
					if (closeModal)
						$uibModalInstance.close('ok');
				}, (promise) => {
					const closeModal = $scope.createCallback(promise);
					if (closeModal)
						$uibModalInstance.close('ok');
				});
				break;
			case 1 :
				if ($scope.form.originalName == '') {
					beneficiariesService.createBeneficiaryDefinition($scope.form).then((promise) => {
						const closeModal = $scope.createCallback(promise);
						if (closeModal) {
							$scope.savePrevious(promise.data);
							if ($scope.customFieldPos + 1 < $scope.previousSettings.length) {
								$scope.emptyFields();
								$scope.customFieldPos++;
								$scope.loadFields();
							} else {
								$uibModalInstance.close('ok');
							}
						}
					}, (promise) => {
						const closeModal = $scope.createCallback(promise);
						if (closeModal) {
							$scope.savePrevious(promise.data);
							if ($scope.customFieldPos + 1 < $scope.previousSettings.length) {
								$scope.emptyFields();
								$scope.customFieldPos++;
								$scope.loadFields();
							} else {
								$uibModalInstance.close('ok');
							}
						}
					});
				} else {
					beneficiariesService.updateBeneficiaryDefinition($scope.managedSchool, $scope.form).then((promise) => {
						const closeModal = $scope.createCallback(promise);
						if (closeModal) {
							$scope.savePrevious(promise.data);
							if ($scope.customFieldPos + 1 < $scope.previousSettings.length) {
								$scope.emptyFields();
								$scope.customFieldPos++;
								$scope.loadFields();
							} else {
								$uibModalInstance.close('ok');
							}
						}
					}, (promise) => {
						const closeModal = $scope.createCallback(promise);
						if (closeModal) {
							$scope.savePrevious(promise.data);
							if ($scope.customFieldPos + 1 < $scope.previousSettings.length) {
								$scope.emptyFields();
								$scope.customFieldPos++;
								$scope.loadFields();
							} else {
								$uibModalInstance.close('ok');
							}
						}
					});
				}
				break;

			case 2 :
				beneficiariesService.updateBeneficiaryDefinition($scope.managedSchool, $scope.form).then((promise) => {
					const closeModal = $scope.createCallback(promise);
					if (closeModal)
						$uibModalInstance.close('ok');
				}, (promise) => {
					const closeModal = $scope.createCallback(promise);
					if (closeModal)
						$uibModalInstance.close('ok');
				});
				break;
		}
	},

	$scope.back = function() {
		$scope.emptyFields();
		$scope.customFieldPos--;
		$scope.loadFields();
	},

	$scope.cancel = function() {
		if (createMode == 1) {
			$uibModalInstance.close('reload');
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	},

	$scope.createCallback = function(response) {
		const r = formHelper.handleResponse(response);

		if (r.isSuccess()) {
			$scope.saving = false;
			return true;
		} else {
			$scope.saving = false;
			return false;
		}
	};
});



// WEBPACK FOOTER //
// ./src/controllers/modal/beneficiaryDefinitionList.controller.js